import * as R from 'ramda';

const mergeConfigs = (strategy, base, xAxis, yAxis, title, override) =>
    R.pipe(
        R.mergeDeepWithKey(strategy, yAxis),
        R.mergeDeepWithKey(strategy, xAxis),
        R.mergeDeepWithKey(strategy, base),
        R.mergeDeepWithKey(strategy, title),
    )(override);

export default mergeConfigs;
